import { onlyDigits } from '@/shared/lib/format';

/** Máscara CPF: 000.000.000-00 */
export function maskCpf(value: string): string {
  const d = onlyDigits(value).slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}

/** Máscara data de aniversário: DD/MM/AAAA */
export function maskBirthday(value: string): string {
  const d = onlyDigits(value).slice(0, 8);
  if (d.length <= 2) return d;
  if (d.length <= 4) return `${d.slice(0, 2)}/${d.slice(2)}`;
  return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
}

/** Máscara brasileira: (11) 99999-9999 ou (11) 9999-9999 */
export function maskPhone(value: string): string {
  const d = onlyDigits(value).slice(0, 11);
  if (d.length === 0) return '';
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

/** Máscara CNPJ: 00.000.000/0000-00 */
export function maskCnpj(value: string): string {
  const d = onlyDigits(value).slice(0, 14);
  if (d.length <= 2) return d;
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`;
  if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
  if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
}

/** Máscara CEP: 00000-000 */
export function maskCep(value: string): string {
  const d = onlyDigits(value).slice(0, 8);
  if (d.length <= 5) return d;
  return `${d.slice(0, 5)}-${d.slice(5)}`;
}

/**
 * Máscara genérica no estilo jquery.mask ("00000-000", "(00) 0000-0000"…) —
 * usada pelos campos customizados do passbook (`addFields[].mask`, cadastro
 * público). '0' no padrão vira slot de dígito; o resto é literal.
 */
export function maskFromPattern(value: string, pattern: string): string {
  const digits = onlyDigits(value);
  let result = '';
  let di = 0;
  for (const ch of pattern) {
    if (di >= digits.length) break;
    if (ch === '0') {
      result += digits[di];
      di++;
    } else {
      result += ch;
    }
  }
  return result;
}

/** Máscara monetária BRL enquanto digita (centavos). */
export function maskCurrency(value: string): string {
  const digits = onlyDigits(value);
  if (!digits) return '';
  const amount = Number(digits) / 100;
  return amount.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Aplica máscara a valor já salvo (edição). */
export function maskCnpjFromStored(value: string | undefined): string {
  return value ? maskCnpj(value) : '';
}

export function maskCpfFromStored(value: string | number | undefined | null): string {
  if (value == null || value === '') return '';
  return maskCpf(String(value));
}

export function maskPhoneFromStored(value: string | undefined): string {
  return value ? maskPhone(value) : '';
}

export function maskBirthdayFromStored(value: string | undefined): string {
  if (!value) return '';
  // Loyalty grava (ou gravava) `yyyy-mm-dd`. A máscara lê só dígitos como
  // DDMMYYYY, então `1990-05-14` aparecia `19/90/0514`.
  const iso = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;
  return maskBirthday(value);
}

export function maskCepFromStored(value: string | undefined): string {
  return value ? maskCep(value) : '';
}

export function maskCurrencyFromStored(value: string | undefined): string {
  if (!value) return '';
  const digits = onlyDigits(value);
  if (!digits) return value;
  return maskCurrency(digits);
}
